"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { MembraneClientContext } from './use-membrane-client.mjs';

const MembraneClientProvider = ({ client, children }) => {
  return /* @__PURE__ */ jsx(MembraneClientContext.Provider, { value: { client }, children });
};

export { MembraneClientProvider };
